import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssistantDataService {
  private drugResponseSubject = new Subject<any>();
  private taskResponseSubject = new Subject<any>();
  drugResponse$ = this.drugResponseSubject.asObservable();
  taskResponse$ = this.taskResponseSubject.asObservable();

  emitDrugResponse(data: any) {
    this.drugResponseSubject.next(data);
  }

  emitTaskResponse(data: any) {
    this.drugResponseSubject.next(data);
  }

}
